<template>
  <div>
    <v-container grid-list-md>
      <v-layout row wrap>
        <v-flex
          xs12
          text-xs-center
          layout
          align-center
          justify-center
        >
          <v-avatar
            size="110"
            color="white"
          >
            <img :src="logoUrl">
          </v-avatar>
        </v-flex>
        <v-flex
          xs12
          text-xs-center
          class="mt-3"
        >
          <h3>{{ profile.name }}</h3>
          {{ profile.roleName }}
        </v-flex>
      </v-layout>
    </v-container>
    <v-list>
      <v-list-group
        v-if="accessSales"
        prepend-icon="shopping_cart"
        :value="expandSales"
      >
        <v-list-tile slot="activator">
          <v-list-tile-title>Sales</v-list-tile-title>
        </v-list-tile>
        <v-list-tile to="/orders/pending" exact>
          <v-list-tile-action></v-list-tile-action>
          <v-list-tile-title>Pending</v-list-tile-title>
        </v-list-tile>
        <v-list-tile to="/orders/in-progress" exact>
          <v-list-tile-action></v-list-tile-action>
          <v-list-tile-title>In-progress</v-list-tile-title>
        </v-list-tile>
        <v-list-tile to="/orders/shipped" exact>
          <v-list-tile-action></v-list-tile-action>
          <v-list-tile-title>Shipped</v-list-tile-title>
        </v-list-tile>
        <v-list-tile to="/orders/unpaid" exact>
          <v-list-tile-action></v-list-tile-action>
          <v-list-tile-title>Unpaid</v-list-tile-title>
        </v-list-tile>
        <v-list-tile to="/orders/canceled" exact>
          <v-list-tile-action></v-list-tile-action>
          <v-list-tile-title>Canceled</v-list-tile-title>
        </v-list-tile>
        <v-list-tile to="/orders/reviewed" exact>
          <v-list-tile-action></v-list-tile-action>
          <v-list-tile-title>Reviewed</v-list-tile-title>
          <v-list-tile-avatar v-if="profile.pendingReviewForReplyCount > 0">
            <v-badge color="red">
              <template v-slot:badge>
                <span class="caption">{{ profile.pendingReviewForReplyCount }}</span>
              </template>
            </v-badge>
          </v-list-tile-avatar>
        </v-list-tile>
        <v-list-tile to="/orders/all" exact>
          <v-list-tile-action></v-list-tile-action>
          <v-list-tile-title>All</v-list-tile-title>
        </v-list-tile>
        <v-list-tile to="/order" v-if="createSales" exact>
          <v-list-tile-action></v-list-tile-action>
          <v-list-tile-title>Create Order</v-list-tile-title>
        </v-list-tile>
      </v-list-group>

      <v-list-group
        prepend-icon="message"
        :value="expandTicket"
      >
        <v-list-tile slot="activator">
          <v-list-tile-title>
            Tickets <span>({{ parseInt(profile.pendingTicketCount) + parseInt(profile.repliedTicketCount) }})</span>
          </v-list-tile-title>
          <v-list-tile-avatar v-if="(parseInt(profile.pendingTicketNewMessageCount) + parseInt(profile.repliedTicketNewMessageCount) + parseInt(profile.otherTicketNewMessageCount) + parseInt(profile.closedTicketNewMessageCount)) > 0">
            <v-badge color="red" small>
              <template v-slot:badge>
                <span>{{ (parseInt(profile.pendingTicketNewMessageCount) + parseInt(profile.repliedTicketNewMessageCount) + parseInt(profile.otherTicketNewMessageCount) + parseInt(profile.closedTicketNewMessageCount)) }}</span>
              </template>
            </v-badge>
          </v-list-tile-avatar>
        </v-list-tile>
        <v-list-tile to="/tickets/pending" exact>
          <v-list-tile-action></v-list-tile-action>
          <v-list-tile-title>
            Pending <span>({{ profile.pendingTicketCount }})</span>
          </v-list-tile-title>
          <v-list-tile-avatar v-if="profile.pendingTicketNewMessageCount > 0">
            <v-badge color="red" small>
              <template v-slot:badge>
                <span>{{ profile.pendingTicketNewMessageCount }}</span>
              </template>
            </v-badge>
          </v-list-tile-avatar>
        </v-list-tile>
        <v-list-tile to="/tickets/replied" exact>
          <v-list-tile-action></v-list-tile-action>
          <v-list-tile-title>
            Replied <span>({{ profile.repliedTicketCount }})</span>
          </v-list-tile-title>
          <v-list-tile-avatar v-if="profile.repliedTicketNewMessageCount > 0">
            <v-badge color="red" small>
              <template v-slot:badge>
                <span>{{ profile.repliedTicketNewMessageCount }}</span>
              </template>
            </v-badge>
          </v-list-tile-avatar>
        </v-list-tile>
        <v-list-tile to="/tickets/others" exact>
          <v-list-tile-action></v-list-tile-action>
          <v-list-tile-title>Others</v-list-tile-title>
          <v-list-tile-avatar v-if="profile.otherTicketNewMessageCount > 0">
            <v-badge color="red" small>
              <template v-slot:badge>
                <span>{{ profile.otherTicketNewMessageCount }}</span>
              </template>
            </v-badge>
          </v-list-tile-avatar>
        </v-list-tile>
        <v-list-tile to="/tickets/closed" exact>
          <v-list-tile-action></v-list-tile-action>
          <v-list-tile-title>Closed</v-list-tile-title>
          <v-list-tile-avatar v-if="profile.closedTicketNewMessageCount > 0">
            <v-badge color="red" small>
              <template v-slot:badge>
                <span>{{ profile.closedTicketNewMessageCount }}</span>
              </template>
            </v-badge>
          </v-list-tile-avatar>
        </v-list-tile>
        <v-list-tile v-if="accessTicket" to="/tickets/all" exact>
          <v-list-tile-action></v-list-tile-action>
          <v-list-tile-title>All</v-list-tile-title>
        </v-list-tile>
        <v-list-tile v-if="createTicket" to="/ticket" exact>
          <v-list-tile-action></v-list-tile-action>
          <v-list-tile-title>Create Ticket</v-list-tile-title>
        </v-list-tile>
      </v-list-group>
      <v-list-group
        v-if="accessPayment"
        prepend-icon="monetization_on"
        :value="expandPayment"
      >
        <v-list-tile slot="activator">
          <v-list-tile-title>Payment</v-list-tile-title>
        </v-list-tile>
        <v-list-tile to="/payments/pending" exact>
          <v-list-tile-action></v-list-tile-action>
          <v-list-tile-title>Pending</v-list-tile-title>
        </v-list-tile>
        <v-list-tile to="/payments/confirmed" exact>
          <v-list-tile-action></v-list-tile-action>
          <v-list-tile-title>Confirmed</v-list-tile-title>
        </v-list-tile>
        <v-list-tile to="/payments/chargeback" exact>
          <v-list-tile-action></v-list-tile-action>
          <v-list-tile-title>Chargeback</v-list-tile-title>
        </v-list-tile>
        <v-list-tile to="/payments/all" exact>
          <v-list-tile-action></v-list-tile-action>
          <v-list-tile-title>All</v-list-tile-title>
        </v-list-tile>
        <v-list-tile to="/payment" v-if="createPayment" exact>
          <v-list-tile-action></v-list-tile-action>
          <v-list-tile-title>Add Payment</v-list-tile-title>
        </v-list-tile>
      </v-list-group>
      <v-list-group
        v-if="accessVoucher"
        prepend-icon="card_giftcard"
        :value="expandVoucher"
      >
        <v-list-tile slot="activator">
          <v-list-tile-title>Voucher</v-list-tile-title>
        </v-list-tile>
        <v-list-tile to="/vouchers" exact>
          <v-list-tile-action></v-list-tile-action>
          <v-list-tile-title>Manage Vouchers</v-list-tile-title>
        </v-list-tile>
        <v-list-tile to="/voucher" v-if="createVoucher" exact>
          <v-list-tile-action></v-list-tile-action>
          <v-list-tile-title>Add Voucher</v-list-tile-title>
        </v-list-tile>
      </v-list-group>
      <v-list-group
        v-if="accessCategory"
        prepend-icon="view_module"
        :value="expandCategory"
      >
        <v-list-tile slot="activator">
          <v-list-tile-title>Category</v-list-tile-title>
        </v-list-tile>
        <v-list-tile to="/categories" exact>
          <v-list-tile-action></v-list-tile-action>
          <v-list-tile-title>Manage Category</v-list-tile-title>
        </v-list-tile>
      </v-list-group>
      <v-list-group
        v-if="accessSchematic"
        prepend-icon="memory"
        :value="expandSchematic"
      >
        <v-list-tile slot="activator">
          <v-list-tile-title>Schematic</v-list-tile-title>
        </v-list-tile>
        <v-list-tile to="/schematics" exact>
          <v-list-tile-action></v-list-tile-action>
          <v-list-tile-title>Manage Schematic</v-list-tile-title>
        </v-list-tile>
        <v-list-tile to="/schematic" v-if="createSchematic" exact>
          <v-list-tile-action></v-list-tile-action>
          <v-list-tile-title>Add Schematic</v-list-tile-title>
        </v-list-tile>
      </v-list-group>
      <v-list-group
        v-if="accessBanner"
        prepend-icon="web"
        :value="expandBanner"
      >
        <v-list-tile slot="activator">
          <v-list-tile-title>Banner</v-list-tile-title>
        </v-list-tile>
        <v-list-tile to="/banner/main/list" exact>
          <v-list-tile-action></v-list-tile-action>
          <v-list-tile-title>Main Banner</v-list-tile-title>
        </v-list-tile>
      </v-list-group>
      <v-list-group
        v-if="accessExpenses"
        prepend-icon="ballot"
        :value="expandExpenses"
      >
        <v-list-tile slot="activator">
          <v-list-tile-title>Expenses</v-list-tile-title>
        </v-list-tile>
        <v-list-tile to="/expenses" exact>
          <v-list-tile-action></v-list-tile-action>
          <v-list-tile-title>Manage Expenses</v-list-tile-title>
        </v-list-tile>
      </v-list-group>
      <v-list-group
        v-if="accessIncomes"
        prepend-icon="payment"
        :value="expandIncomes"
      >
        <v-list-tile slot="activator">
          <v-list-tile-title>Incomes</v-list-tile-title>
        </v-list-tile>
        <v-list-tile to="/incomes" exact>
          <v-list-tile-action></v-list-tile-action>
          <v-list-tile-title>Manage Incomes</v-list-tile-title>
        </v-list-tile>
      </v-list-group>
      <v-list-group
        v-if="accessSales"
        prepend-icon="flight"
        :value="expandCourier"
      >
        <v-list-tile slot="activator">
          <v-list-tile-title>Courier</v-list-tile-title>
        </v-list-tile>
        <v-list-tile to="/courier/rates" exact>
          <v-list-tile-action></v-list-tile-action>
          <v-list-tile-title>Shipping Rates</v-list-tile-title>
        </v-list-tile>
      </v-list-group>
      <v-list-group
        prepend-icon="person_outline"
        :value="expandCustomer"
      >
        <v-list-tile slot="activator">
          <v-list-tile-title>Customers</v-list-tile-title>
        </v-list-tile>
        <v-list-tile to="/customers" exact>
          <v-list-tile-action></v-list-tile-action>
          <v-list-tile-title>Manage Customer</v-list-tile-title>
        </v-list-tile>
        <v-list-tile to="/customer" v-if="createCustomer" exact>
          <v-list-tile-action></v-list-tile-action>
          <v-list-tile-title>Create Customer</v-list-tile-title>
        </v-list-tile>
      </v-list-group>
      <v-list-group
        prepend-icon="store"
        :value="expandSeller"
      >
        <v-list-tile slot="activator">
          <v-list-tile-title>Sellers</v-list-tile-title>
        </v-list-tile>
        <v-list-tile to="/sellers" exact>
          <v-list-tile-action></v-list-tile-action>
          <v-list-tile-title>Manage Seller</v-list-tile-title>
        </v-list-tile>
      </v-list-group>
      <v-list-group
        v-if="accessAdmin"
        prepend-icon="person"
        :value="expandAdmin"
      >
        <v-list-tile slot="activator">
          <v-list-tile-title>Admins</v-list-tile-title>
        </v-list-tile>
        <v-list-tile to="/admins" exact>
          <v-list-tile-action></v-list-tile-action>
          <v-list-tile-title>Manage Admin</v-list-tile-title>
        </v-list-tile>
        <v-list-tile to="/admin" exact>
          <v-list-tile-action></v-list-tile-action>
          <v-list-tile-title>Create Admin</v-list-tile-title>
        </v-list-tile>
      </v-list-group>
      <v-list-group
        v-if="accessReport || accessReportSales || accessReportProfit"
        prepend-icon="timeline"
        :value="expandReport"
      >
        <v-list-tile slot="activator">
          <v-list-tile-title>Reports & Logs</v-list-tile-title>
        </v-list-tile>
        <v-list-tile to="/report/sales" v-if="accessReportSales" exact>
          <v-list-tile-action></v-list-tile-action>
          <v-list-tile-title>Sales Report</v-list-tile-title>
        </v-list-tile>
        <v-list-tile to="/report/profit" v-if="accessReportProfit" exact>
          <v-list-tile-action></v-list-tile-action>
          <v-list-tile-title>Gross Profit Report</v-list-tile-title>
        </v-list-tile>
        <v-list-tile :to="'/report/net-profit/' + new Date().getFullYear() + '/' + (new Date().getMonth() + 1)" v-if="accessReportProfit" exact>
          <v-list-tile-action></v-list-tile-action>
          <v-list-tile-title>Net Profit Report By Month</v-list-tile-title>
        </v-list-tile>
        <v-list-tile :to="'/report/net-profit/' + new Date().getFullYear()" v-if="accessReportProfit" exact>
          <v-list-tile-action></v-list-tile-action>
          <v-list-tile-title>Net Profit Report By Year</v-list-tile-title>
        </v-list-tile>
        <v-list-tile to="/report/middle-rates" v-if="accessReportProfit || accessReportSales" exact>
          <v-list-tile-action></v-list-tile-action>
          <v-list-tile-title>Middle Rates Report</v-list-tile-title>
        </v-list-tile>
        <v-list-tile to="/logs/search" v-if="accessReport" exact>
          <v-list-tile-action></v-list-tile-action>
          <v-list-tile-title>Search Logs</v-list-tile-title>
        </v-list-tile>
        <v-list-tile to="/logs/user" v-if="accessReport" exact>
          <v-list-tile-action></v-list-tile-action>
          <v-list-tile-title>User Logs</v-list-tile-title>
        </v-list-tile>
        <v-list-tile to="/logs/admin" v-if="accessReport" exact>
          <v-list-tile-action></v-list-tile-action>
          <v-list-tile-title>Admin Logs</v-list-tile-title>
        </v-list-tile>
      </v-list-group>
      <v-list-group
        prepend-icon="face"
        :value="expandMyAccount"
      >
        <v-list-tile slot="activator">
          <v-list-tile-title>My Account</v-list-tile-title>
        </v-list-tile>
        <v-list-tile to="/me/profile" exact>
          <v-list-tile-action></v-list-tile-action>
          <v-list-tile-title>Update Profile</v-list-tile-title>
        </v-list-tile>
        <v-list-tile to="/me/password" exact>
          <v-list-tile-action></v-list-tile-action>
          <v-list-tile-title>Change Password</v-list-tile-title>
        </v-list-tile>
      </v-list-group>
      <v-list-tile @click="logout()">
        <v-list-tile-action>
          <v-icon>exit_to_app</v-icon>
        </v-list-tile-action>
        <v-list-tile-title>Log out</v-list-tile-title>
      </v-list-tile>
    </v-list>
    <div class="caption font-weight-light pa-3 mt-4 grey--text">
      Admin Version 1.8.1
    </div>
  </div>
</template>

<script>
import router from '../router'
import { EventBus } from '../main'

export default {
  data () {
    return {
      logoUrl: process.env.VUE_APP_LOGO_URL,
      profile: this.$store.getters.getProfile,
      autoloadInterval: null,
      expandSales: false,
      expandReview: false,
      expandTicket: false,
      expandPayment: false,
      expandVoucher: false,
      expandCategory: false,
      expandSchematic: false,
      expandBanner: false,
      expandExpenses: false,
      expandIncomes: false,
      expandCourier: false,
      expandCustomer: false,
      expandSeller: false,
      expandAdmin: false,
      expandReport: false,
      expandMyAccount: false,
      accessCategory: false,
      accessSchematic: false,
      createSchematic: false,
      accessBanner: false,
      accessExpenses: false,
      accessIncomes: false,
      accessSales: false,
      createSales: false,
      accessTicket: false,
      createTicket: false,
      accessPayment: false,
      createPayment: false,
      accessVoucher: false,
      createVoucher: false,
      accessCustomer: false,
      createCustomer: false,
      accessAdmin: false,
      accessReport: false,
      accessReportSales: false,
      accessReportProfit: false
    }
  },
  created () {
    var _this = this
    EventBus.$on('profileUpdated', profile => {
      _this.profile = profile
    })
    EventBus.$on('logout', function () {
      clearInterval(_this.autoloadInterval)
    })
    EventBus.$on('disableProfileRefresh', function () {
      clearInterval(_this.autoloadInterval)
    })
  },
  mounted () {
    this.$store.dispatch('UPDATE_PROFILE')
    this.showMenu()
    this.expandMenu()

    var _this = this
    _this.autoloadInterval = setInterval(function () {
      _this.$store.dispatch('UPDATE_PROFILE')
    }, (2 * 60 * 1000))
  },
  methods: {
    expandMenu: function () {
      var fullPath = this.$router.currentRoute.fullPath
      var paths = fullPath.split('/')
      console.log(paths)
      if (paths[1] === 'order' || paths[1] === 'orders') {
        this.expandSales = true
      } else if (paths[1] === 'reviews') {
        this.expandReview = true
      } else if (paths[1] === 'ticket' || paths[1] === 'tickets') {
        this.expandTicket = true
      } else if (paths[1] === 'payment' || paths[1] === 'payments') {
        this.expandPayment = true
      } else if (paths[1] === 'voucher' || paths[1] === 'vouchers') {
        this.expandVoucher = true
      } else if (paths[1] === 'categories') {
        this.expandCategory = true
      } else if (paths[1] === 'schematic' || paths[1] === 'schematics') {
        this.expandSchematic = true
      } else if (paths[1] === 'banner') {
        this.expandBanner = true
      } else if (paths[1] === 'expense') {
        this.expandExpenses = true
      } else if (paths[1] === 'income') {
        this.expandIncomes = true
      } else if (paths[1] === 'courier' || paths[1] === 'couriers') {
        this.expandCourier = true
      } else if (paths[1] === 'customer' || paths[1] === 'customers') {
        this.expandCustomer = true
      } else if (paths[1] === 'seller' || paths[1] === 'sellers') {
        this.expandSeller = true
      } else if (paths[1] === 'admin' || paths[1] === 'admins') {
        this.expandAdmin = true
      } else if (paths[1] === 'logs' || paths[1] === 'report') {
        this.expandReport = true
      } else if (paths[1] === 'me') {
        this.expandMyAccount = true
      }
    },
    showMenu: function () {
      for (var i = 0, len = this.profile.permissions.length; i < len; i++) {
        if (this.profile.permissions[i].permissionId === 'PEM-SALES' && this.profile.permissions[i].isRead === '1') {
          this.accessSales = true
        }
        if (this.profile.permissions[i].permissionId === 'PEM-SALES' && this.profile.permissions[i].isCreate === '1') {
          this.createSales = true
        }
        if (this.profile.permissions[i].permissionId === 'PEM-TICKET' && this.profile.permissions[i].isRead === '1') {
          this.accessTicket = true
        }
        if (this.profile.permissions[i].permissionId === 'PEM-TICKET' && this.profile.permissions[i].isCreate === '1') {
          this.createTicket = true
        }
        if (this.profile.permissions[i].permissionId === 'PEM-PAYMENT' && this.profile.permissions[i].isRead === '1') {
          this.accessPayment = true
        }
        if (this.profile.permissions[i].permissionId === 'PEM-PAYMENT' && this.profile.permissions[i].isCreate === '1') {
          this.createPayment = true
        }
        if (this.profile.permissions[i].permissionId === 'PEM-VOUCHER' && this.profile.permissions[i].isRead === '1') {
          this.accessVoucher = true
        }
        if (this.profile.permissions[i].permissionId === 'PEM-VOUCHER' && this.profile.permissions[i].isCreate === '1') {
          this.createVoucher = true
        }
        if (this.profile.permissions[i].permissionId === 'PEM-CATEGORY' && this.profile.permissions[i].isRead === '1') {
          this.accessCategory = true
        }
        if (this.profile.permissions[i].permissionId === 'PEM-SCHEMATIC' && this.profile.permissions[i].isRead === '1') {
          this.accessSchematic = true
        }
        if (this.profile.permissions[i].permissionId === 'PEM-SCHEMATIC' && this.profile.permissions[i].isUpdate === '1') {
          this.createSchematic = true
        }
        if (this.profile.permissions[i].permissionId === 'PEM-BANNER' && this.profile.permissions[i].isRead === '1') {
          this.accessBanner = true
        }
        if (this.profile.permissions[i].permissionId === 'PEM-EXPENSES' && this.profile.permissions[i].isRead === '1') {
          this.accessExpenses = true
          this.accessIncomes = true
        }
        if (this.profile.permissions[i].permissionId === 'PEM-USER' && this.profile.permissions[i].isRead === '1') {
          this.accessCustomer = true
        }
        if (this.profile.permissions[i].permissionId === 'PEM-USER' && this.profile.permissions[i].isCreate === '1') {
          this.createCustomer = true
        }
        if (this.profile.permissions[i].permissionId === 'PEM-BANNER' && this.profile.permissions[i].isRead === '1') {
          this.accessBanner = true
        }
        if (this.profile.permissions[i].permissionId === 'PEM-ADMIN' && this.profile.permissions[i].isUpdate === '1') {
          this.accessAdmin = true
        }
        if (this.profile.permissions[i].permissionId === 'PEM-REPORT' && this.profile.permissions[i].isRead === '1') {
          this.accessReport = true
        }
        if (this.profile.permissions[i].permissionId === 'PEM-REPSALES' && this.profile.permissions[i].isRead === '1') {
          this.accessReportSales = true
        }
        if (this.profile.permissions[i].permissionId === 'PEM-COSTING' && this.profile.permissions[i].isRead === '1') {
          this.accessReportProfit = true
        }
      }
    },
    logout: function () {
      this.$store.dispatch('AUTH_LOGOUT')
        .then(() => {
          clearInterval(this.autoloadInterval)
          router.push('/login')
        })
    }
  }
}
</script>

<style scoped>
</style>
